import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseArtistDetailsProps {
  artistId: string;
}

export const useArtistDetails = ({ artistId }: UseArtistDetailsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const artistDetailsQuery = useTRPCQuery(
    trpcMusicAPI.artists.details.queryOptions({
      artistId,
      ...shareTokenInput,
    })
  );

  return artistDetailsQuery;
};
